import React, { useEffect, useRef } from 'react';
import { useGazeData } from '../../hooks/useGazeData';

const GazeTrailCanvas = () => {
    const canvasRef = useRef(null);
    const moduleRef = useRef(null);

    // Get mode from query parameter
    const getMode = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('simulategaze') === null && window.eyeTracking ? 'gaze' : 'mouse';
    };

    const mode = getMode();

    useGazeData(({ x, y }) => {
        window.Module?.ccall(
            'set_gaze_coordinate',
            null,
            ['number', 'number'],
            [x, y]
        );
    }, mode !== 'mouse');


    useEffect(() => {
        if (!canvasRef.current) return;

        // Configure the Emscripten Module
        window.Module = {
            canvas: canvasRef.current,
            print: (text) => {
                console.log(text);
            },
            onRuntimeInitialized: () => {
                window.Module.ccall(
                    'set_draw_mode',
                    null,
                    ['string'],
                    [mode]
                );
            }
        };

        moduleRef.current = window.Module;

        // Load the WebAssembly script
        const script = document.createElement('script');
        script.src = '/wasm/gaze-trail.js'; // Adjust path as needed
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [mode]);

    return (
        <canvas
            ref={canvasRef}
            id="canvas"
            onContextMenu={(e) => e.preventDefault()}
            tabIndex={-1}
            style={{
                border: 'none',
                backgroundColor: 'black',
                display: 'block'
            }}
        />
    );
};

export default GazeTrailCanvas;